const buttonsPermissionsChecker = (permission) => {
  const userRoles = JSON.parse(localStorage.getItem("userRoles"));
  const allPermissions = userRoles?.data?.roles?.flatMap(
    (item) => item.permissions
  );
  const couldShow = allPermissions?.some((item) => item.id === permission);
  return couldShow ? true : false;
};
export default buttonsPermissionsChecker;
